'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var InputGroup = require('./InputGroup');
var Input = require('./Input');
var Select = require('./Select');
var Mixin = require('../mixin');

var Phone = (function (_React$Component) {
    _inherits(Phone, _React$Component);

    function Phone(props) {
        _classCallCheck(this, Phone);

        _get(Object.getPrototypeOf(Phone.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Phone';
        this.state = {
            countryCodes: this.props.telephones.map(function (item) {
                return {
                    label: item.display,
                    value: item.country
                };
            })
        };
    }

    _createClass(Phone, [{
        key: 'onChange',
        value: function onChange(field, value) {
            var phone = this.cloneObject(this.props.phone);
            phone[field] = value;
            this.props.onChange(phone);
        }
    }, {
        key: 'render',
        value: function render() {
            var extension = _react2['default'].createElement(Input, {
                type: 'text',
                value: this.props.phone.extensionNumber,
                errors: this.getErrors('extensionNumber'),
                readOnly: this.props.readOnly,
                disabled: this.props.disabled,
                id: 'extensionNumber',
                label: this.i18n(this.props.dictionary, 'extension.label'),
                onChange: this.onChange.bind(this, 'extensionNumber')
            });

            return _react2['default'].createElement(
                InputGroup,
                {
                    contiguous: true,
                    label: this.props.label,
                    id: this.props.id,
                    error: this.hasErrors()
                },
                _react2['default'].createElement(
                    InputGroup.Section,
                    null,
                    _react2['default'].createElement(Select, {
                        options: this.state.countryCodes,
                        label: this.i18n(this.props.dictionary, 'country.label'),
                        value: this.props.phone.countryCode,
                        errors: this.getErrors('countryCode'),
                        id: 'countryCode',
                        placeholder: this.i18n(this.props.dictionary, 'country.label'),
                        readOnly: this.props.readOnly,
                        disabled: this.props.disabled,
                        onChange: this.onChange.bind(this, 'countryCode')
                    }),
                    _react2['default'].createElement(Input, {
                        type: 'text',
                        value: this.props.phone.nationalNumber,
                        errors: this.getErrors('nationalNumber'),
                        readOnly: this.props.readOnly,
                        disabled: this.props.disabled,
                        id: 'nationalNumber',
                        label: this.i18n(this.props.dictionary, 'nationalNumber.label'),
                        onChange: this.onChange.bind(this, 'nationalNumber')
                    }),
                    this.props.extension ? extension : ''
                )
            );
        }
    }]);

    return Phone;
})(_react2['default'].Component);

Phone.propTypes = {
    phone: _propTypes2['default'].shape({
        countryCode: _propTypes2['default'].string,
        nationalNumber: _propTypes2['default'].string,
        extensionNumber: _propTypes2['default'].string
    }),
    telephones: _propTypes2['default'].arrayOf(_propTypes2['default'].object).isRequired, //TODO: add custom propType validation.
    dictionary: _propTypes2['default'].object.isRequired,
    onChange: _propTypes2['default'].func.isRequired,
    label: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    readOnly: _propTypes2['default'].bool,
    errors: _propTypes2['default'].object,
    extension: _propTypes2['default'].bool,
    id: _propTypes2['default'].string
};

Phone.defaultProps = {
    extention: false,
    phone: {}
};

(0, _reactMixin2['default'])(Phone.prototype, Mixin);

module.exports = Phone;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Phone.js
// module id = 973
// module chunks = 0 1